//@flow
import React from 'react';
import {connect} from 'react-redux';
import {makeStyles, Typography} from '@material-ui/core';
import {LocalShipping} from '@material-ui/icons';

import {commaFormat} from '../../../../utils/number';
import {colors} from '../../../../assets/styles/colors';

import type {RootState} from '../../../index';
import type {Currency} from '../../../../entities';

type Props = {
  deliveryCost?: string,
  subTotal?: string,
  currency: Currency,
  minOrderAmount?: string,
  hasDeliveryPromotion?: boolean,
};

const useStyle = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '18px',
    borderRadius: '12px',
    background: colors.grey200,
    margin: '8px 0',
  },
  deliveryPromotion: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    justifyContent: 'flex-start',
    fontSize: '14px',
  },
  remainingAmount: {
    fontWeight: 600,
    color: colors.purple,
  },
  containerLine: {
    width: '100%',
    background: colors.grey300,
    height: '4px',
    borderRadius: '4px',
  },
  promotionIcon: {
    color: colors.purple,
  },
  line: {
    height: '4px',
    borderRadius: '4px',
    background: colors.purple,
  },
  promotionLabel: {
    fontSize: '14px',
    fontWeight: 500,
    color: colors.grey800,
  },
}));

function DeliveryPromotion(props: Props) {
  const {
    deliveryCost,
    subTotal = '0',
    currency,
    minOrderAmount,
    hasDeliveryPromotion,
  } = props;

  const classes = useStyle();

  const remainingAmount = Number(minOrderAmount) - Number(subTotal);

  const percentageWidthCost = () => {
    if (subTotal && minOrderAmount) {
      if (Number(minOrderAmount) > Number(subTotal)) {
        return ((Number(subTotal) / Number(minOrderAmount)) * 100).toFixed(2);
      } else {
        return 100;
      }
    }
    return 0;
  };

  if (!hasDeliveryPromotion) return null;

  return (
    <div className={classes.root}>
      <div className={classes.deliveryPromotion}>
        <LocalShipping className={classes.promotionIcon} />
        {remainingAmount > 0 ? (
          <Typography className={classes.promotionLabel}>
            Agrega{' '}
            <span className={classes.remainingAmount}>
              {commaFormat(remainingAmount, currency.symbol)}
            </span>{' '}
            para tener envío{' '}
            {deliveryCost === '0.00'
              ? 'GRATIS!'
              : commaFormat(deliveryCost || 0, currency.symbol)}
          </Typography>
        ) : (
          <Typography className={classes.promotionLabel}>
            Promoción de envío aplicada
          </Typography>
        )}
      </div>
      <div className={classes.containerLine}>
        <div
          className={classes.line}
          style={{
            width: `${percentageWidthCost()}%`,
          }}
        />
      </div>
    </div>
  );
}

export default connect((state: RootState) => ({
  subTotal: state.manualOrder.subTotal,
  deliveryCost:
    state.logisticsConfig.shippingMethod &&
    state.logisticsConfig.shippingMethod.storeShippingMethodPromotion &&
    state.logisticsConfig.shippingMethod.storeShippingMethodPromotion.price,
  minOrderAmount:
    state.logisticsConfig.shippingMethod &&
    state.logisticsConfig.shippingMethod.storeShippingMethodPromotion &&
    state.logisticsConfig.shippingMethod.storeShippingMethodPromotion
      .minOrderAmount,
  hasDeliveryPromotion: !!(
    state.logisticsConfig.shippingMethod &&
    state.logisticsConfig.shippingMethod.enabledPromotions &&
    state.logisticsConfig.shippingMethod.storeShippingMethodPromotion
  ),
}))(DeliveryPromotion);
